import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Marketing from './Marketing';

// Коренева сторінка: гість бачить промо-лендінг платформи, залогінені — редірект за роллю.
export default function Home() {
  const { user, loading } = useAuth();

  if (loading) return null;
  // Гість бачить маркетинговий лендінг платформи (реклама/презентація)
  if (!user) return <Marketing />;
  if (user.role === 'superadmin')
    return <Navigate to="/admin/workspaces" replace />;
  if (user.role === 'master' || user.role === 'admin')
    return <Navigate to="/master/dashboard" replace />;
  return <Navigate to="/user/cabinet" replace />;
}
